
// Removed import socket from '../socket';
import { IManualMovement } from '../shared/types';

export const createMovement = (socket: any, movement: IManualMovement) => { // Added socket parameter
  socket.send('addMovement', { data: movement });
};

export const createMovementsBatch = (socket: any, movements: IManualMovement[]) => {
  if (!Array.isArray(movements) || movements.length === 0) {
    return;
  }

  const payload = movements.map(({ botId, movementType, date, token, quantity, price, amountUSD, smartSellConfig, targetInstance }) => ({
    botId,
    movementType,
    date,
    token: token ?? undefined,
    quantity: quantity !== undefined ? Number(quantity) : undefined,
    price: price !== undefined ? Number(price) : undefined,
    amountUSD: Number(amountUSD),
    smartSellConfig: smartSellConfig ?? undefined,
    // Which trading bot (dipster/dumper) runs the task created for premiums and smart sells.
    targetInstance: targetInstance ?? undefined,
  }));

  socket.send('addMovementBatch', { data: payload });
};

export const updateMovement = (socket: any, movement: IManualMovement) => { // Added socket parameter
  socket.send('updateMovement', { id: movement.id, data: movement });
};

export const deleteMovement = (socket: any, id: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const handleSuccess = (data: any) => {
      if (data.message) { // Or check for a specific ID if the backend sends it
        cleanup();
        resolve();
      }
    };

    const handleError = (error: any) => {
      cleanup();
      reject(new Error(error.error || 'Unknown error'));
    };

    const cleanup = () => {
      socket.off('movementDeleted', handleSuccess);
      socket.off('movementError', handleError);
    };

    socket.on('movementDeleted', handleSuccess);
    socket.on('movementError', handleError);

    socket.send('deleteMovement', { id });

    // Optional: Add a timeout to prevent the promise from hanging indefinitely
    setTimeout(() => {
      cleanup();
      reject(new Error('Operation timed out'));
    }, 10000); // 10 seconds timeout
  });
};
